import { ChargingNetworkWiseConstant } from "./ChargingNetworkWiseConstant";

const ChargingNetworkWiseActions = {};

ChargingNetworkWiseActions.getChargingNetworkWiseActions = () => {
  return {
    type: ChargingNetworkWiseConstant.CHARGING_NETWORK_WISE_SAGA,
  };
};

export { ChargingNetworkWiseActions };
